module.exports = __webpack_public_path__ + "static/Sprouts-3361cc119e9e2b21df0cb482152dbc7a.jpg";